<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Fichero: (s3-key) </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.file_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.file_location"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Lista intervalos: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.list_of_intervals_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.list_of_intervals_location"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.save_list_key"
                    label="Clave de guardado"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.save_list_key"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        
    </div>
</template>

<script>
import { SplitFile } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';

export default {
    name:'SplitFileDetailComponent',
    components: {
        RouteInBagSelectorComponent
    },
    props:{
        stage: {
            type: SplitFile,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        my_bag: {
            type: Object,
            default: () => {}
        }
    },
    data(){
        return {
        }
    },
    mounted(){
        console.log(this.stage);
    },
    methods:{
        computeStage(){
            this.$emit('compute-stage');
        }
    },
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>